package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.PartnerHeartW500Rounded: ImageVector
    get() {
        if (_partnerHeartW500Rounded != null) {
            return _partnerHeartW500Rounded!!
        }
        _partnerHeartW500Rounded = Builder(name = "PartnerHeartW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 812.91f)
                quadToRelative(-42.28f, 0.0f, -82.8f, -12.78f)
                quadToRelative(-40.53f, -12.78f, -75.53f, -36.35f)
                verticalLineToRelative(48.42f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.33f, 13.18f)
                horizontalLineToRelative(-200.0f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.18f)
                quadToRelative(-13.18f, -13.17f, -13.18f, -32.32f)
                verticalLineToRelative(-120.0f)
                quadToRelative(0.0f, -36.16f, 25.18f, -60.83f)
                quadToRelative(25.17f, -24.67f, 60.32f, -24.67f)
                horizontalLineToRelative(132.44f)
                quadToRelative(20.72f, 0.0f, 37.88f, 9.28f)
                quadToRelative(17.16f, 9.28f, 27.68f, 25.56f)
                quadToRelative(29.48f, 40.2f, 72.94f, 62.68f)
                quadTo(430.57f, 726.7f, 480.0f, 726.7f)
                quadToRelative(50.2f, 0.0f, 93.77f, -22.48f)
                quadToRelative(43.58f, -22.48f, 72.3f, -62.68f)
                quadToRelative(12.04f, -16.28f, 28.82f, -25.56f)
                quadToRelative(16.78f, -9.28f, 36.5f, -9.28f)
                horizontalLineToRelative(132.68f)
                quadToRelative(36.15f, 0.0f, 60.82f, 24.67f)
                quadToRelative(24.68f, 24.67f, 24.68f, 60.83f)
                verticalLineToRelative(120.0f)
                quadToRelative(0.0f, 19.15f, -13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                horizontalLineToRelative(-200.0f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                verticalLineToRelative(-47.66f)
                quadToRelative(-35.0f, 23.57f, -75.15f, 35.97f)
                quadToRelative(-40.14f, 12.4f, -83.42f, 12.4f)
                close()
                moveTo(160.0f, 557.13f)
                quadToRelative(-50.96f, 0.0f, -86.67f, -35.72f)
                quadToRelative(-35.72f, -35.71f, -35.72f, -86.67f)
                quadToRelative(0.0f, -51.72f, 35.72f, -87.06f)
                quadToRelative(35.71f, -35.33f, 86.67f, -35.33f)
                quadToRelative(51.72f, 0.0f, 87.05f, 35.33f)
                quadToRelative(35.34f, 35.34f, 35.34f, 87.06f)
                quadToRelative(0.0f, 50.96f, -35.34f, 86.67f)
                quadToRelative(-35.33f, 35.72f, -87.05f, 35.72f)
                close()
                moveTo(800.0f, 557.13f)
                quadToRelative(-50.96f, 0.0f, -86.67f, -35.72f)
                quadToRelative(-35.72f, -35.71f, -35.72f, -86.67f)
                quadToRelative(0.0f, -51.72f, 35.72f, -87.06f)
                quadToRelative(35.71f, -35.33f, 86.67f, -35.33f)
                quadToRelative(51.72f, 0.0f, 87.05f, 35.33f)
                quadToRelative(35.34f, 35.34f, 35.34f, 87.06f)
                quadToRelative(0.0f, 50.96f, -35.34f, 86.67f)
                quadToRelative(-35.33f, 35.72f, -87.05f, 35.72f)
                close()
                moveTo(480.0f, 117.63f)
                quadToRelative(18.04f, -20.76f, 43.68f, -33.26f)
                quadToRelative(25.65f, -12.5f, 53.17f, -12.5f)
                quadToRelative(51.95f, 0.0f, 88.03f, 35.96f)
                quadToRelative(36.08f, 35.95f, 36.08f, 86.91f)
                quadToRelative(0.0f, 45.24f, -33.21f, 90.61f)
                reflectiveQuadTo(522.54f, 433.04f)
                quadToRelative(-18.15f, 16.44f, -42.16f, 16.44f)
                quadToRelative(-24.01f, 0.0f, -42.92f, -16.44f)
                quadToRelative(-112.0f, -102.32f, -145.21f, -147.69f)
                quadToRelative(-33.21f, -45.37f, -33.21f, -90.61f)
                quadToRelative(0.0f, -50.96f, 36.08f, -86.91f)
                quadToRelative(36.08f, -35.96f, 88.27f, -35.96f)
                quadToRelative(27.52f, 0.0f, 53.04f, 12.38f)
                quadToRelative(25.53f, 12.38f, 43.57f, 33.38f)
                close()
                moveTo(480.0f, 353.11f)
                quadToRelative(69.85f, -62.89f, 102.29f, -100.21f)
                quadToRelative(32.45f, -37.31f, 32.45f, -58.16f)
                quadToRelative(0.0f, -15.33f, -10.92f, -25.99f)
                quadToRelative(-10.93f, -10.66f, -26.49f, -10.66f)
                quadToRelative(-11.76f, 0.0f, -22.31f, 6.88f)
                quadToRelative(-10.54f, 6.88f, -21.59f, 19.2f)
                lineToRelative(-52.67f, 56.61f)
                lineToRelative(-52.43f, -55.08f)
                quadToRelative(-12.57f, -13.85f, -23.23f, -20.73f)
                quadToRelative(-10.67f, -6.88f, -22.43f, -6.88f)
                quadToRelative(-15.56f, 0.0f, -26.49f, 10.66f)
                quadToRelative(-10.92f, 10.66f, -10.92f, 25.99f)
                quadToRelative(0.0f, 20.85f, 32.45f, 58.16f)
                quadTo(410.15f, 290.22f, 480.0f, 353.11f)
                close()
                moveTo(480.0f, 353.11f)
                close()
            }
        }
        .build()
        return _partnerHeartW500Rounded!!
    }

private var _partnerHeartW500Rounded: ImageVector? = null
